<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-100">
      <article-edit-form
        ref="article-edit-form"
        header-color="green"
      ></article-edit-form>
    </div>
  </div>
</template>
<script>
import ArticleEditForm from "./ArticleUpdateComponent/ArticleEditForm";

export default {
  components: {
    ArticleEditForm
  },
  methods: {
    getArticles(articleID) {
      this.$store
        .getArticle(articleID)
        .then(response => {
          if (response.data.university) {
            this.$refs["article-edit-form"].university =
              response.data.university.id;
          }
          this.$refs["article-edit-form"].title = response.data.title;
          this.$refs["article-edit-form"].category = response.data.category;
          this.$refs["article-edit-form"].short_info = response.data.short_info;
          this.$refs["article-edit-form"].content = response.data.content;
          this.$refs["article-edit-form"].image = response.data.image;
          this.$refs["article-edit-form"].is_public = response.data.is_public;
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.detail,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    }
  },
  mounted() {
    this.getArticles(this.$route.params.id);
  }
};
</script>
